import { apiBasePath } from '../baseUrl';
import { apiUrl } from '../../utils/api';
import { DEFAULT_PAGE, DEFAULT_PER_PAGE } from '../../constants/pagination';

export const extendedApi = apiBasePath.injectEndpoints({
  endpoints: (build) => ({
    getStateTax: build.query({
      query: (args) => {
        if (args) {
          const { page, perPage, searchParams = '', id } = args;
          return `${apiUrl.stateTaxHistory}/state/${id}?perPage=${perPage || DEFAULT_PER_PAGE}&page=${
            page || DEFAULT_PAGE
          }&${searchParams}`;
        }
        return `${apiUrl.stateTaxHistory}`;
      },
      transformResponse: (responseData) => responseData,
      providesTags: ['StateTax'],
    }),
    createStateTax: build.mutation({
      query: (data) => ({
        url: `${apiUrl.stateTaxHistory}`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['StateTax'],
    }),
    deleteStateTax: build.mutation({
      query: (data) => ({
        url: `${apiUrl.stateTaxHistory}`,
        method: 'DELETE',
        body: data,
      }),
      invalidatesTags: ['StateTax'],
    }),
  }),
  overrideExisting: false,
});

export const { useGetStateTaxQuery, useCreateStateTaxMutation, useDeleteStateTaxMutation } = extendedApi;
